<script lang="ts">
	import { interval, map, of, startWith, switchMap } from "rxjs";
	import { fade, fly } from "svelte/transition";

	const icons = [
		'icon-bakery-24',
		'icon-bar-24',
		'icon-battery-24',
		'icon-beach-umbrella-24',
		'icon-burger-24',
		'icon-flatware-24',
		'icon-flower-24',
		'icon-icecream-24',
		'icon-liquor-24',
		'icon-moped-24',
		'icon-phone-24',
		'icon-pizza-24',
		'icon-ramen-24',
		'icon-sim-card-24',
		'icon-weight-24'
	];

	const icon$ = of([...icons].sort(() => Math.random() - 0.5)).pipe(
		switchMap((array) => interval(1200).pipe(
			startWith(icons.length - 1),
			map((i) => array[i%icons.length]),
		)),
	);
</script>

<div class="ll"></div>

<style lang="scss">
	@use 'ease';
	@use 'color';

	.ll {
		width: 20px;
		height: 20px;
		&:before {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			border-radius: 100px;
			content: '';
			opacity: 0;
			animation: fadeIn .1s forwards;
		}
		&:after {
			position: absolute;
			top: calc(50% - 15px);
			left: calc(50% - 15px);
			display: block;
			width: 30px;
			aspect-ratio: 1;
			border-radius: 50%;
			background: 
    	radial-gradient(farthest-side, color.$on-background-medium-importance 94%,rgba(0,0,0,0)) top/5px 5px no-repeat,
    	conic-gradient(rgba(0,0,0,0) 30%, color.$on-background-medium-importance);
			mask: radial-gradient(farthest-side,rgba(0,0,0,0) calc(100% - 5px),rgb(0,0,0) 0);
			animation: rotate 0.6s linear infinite, fadeIn .4s .2s forwards;
			content: '';
			opacity: 0;
		}
	}
	@keyframes rotate {to{transform: rotate(1turn)}}
	@keyframes fadeIn {from{opacity: 0;} to{opacity: 1;}}
</style>
